import { store } from './store';
import { trans } from '../utils/trans';
import { RootState } from './reducers';
import { ConfigPriceLayout } from '../types/config';

export const t = (key: string, params = {}, fallback = '') => {
  const state: RootState = store.getState();
  if (!state) {
    return key;
  }

  const locale = state.app.locale;
  const translations = state.system.translations;

  return trans(key, locale, translations, params, fallback);
};

export const configT = (key: string, params = {}, fallback = '') => {
  const state: RootState = store.getState();
  if (!state) {
    return key;
  }

  const cLocale = state.app.configLocale;
  const cTranslations = state.system.configTranslations;

  return trans(key, cLocale, cTranslations, params, fallback);
};

export enum DecimalSeparator {
  Comma = 'comma',
}

export enum CurrencyPosition {
  CurrencyBefore = 'before',
  CurrencyAfter = 'after',
}

export function formatPrice(cents: number, plusMinusSign: string = ''): string {
  if (!cents && cents !== 0) {
    return '';
  }

  const state: RootState = store.getState();
  if (!state || !state.system || !state.system.widgetConfig) {
    return '';
  }

  const priceLayout: ConfigPriceLayout = state.system.widgetConfig.advanced.general.priceLayout;
  const currency: string = state.system.currency;
  const currencyPosition: string = state.system.pricing?.format.currencyPosition;
  const decimalSeparator: string = state.system.pricing?.format.decimalSeparator;

  const price = cents / 100;
  let priceString = '';

  if (priceLayout === ConfigPriceLayout.Rounded) {
    priceString = price.toFixed(0);
  } else if (decimalSeparator === DecimalSeparator.Comma) {
    priceString = price.toFixed(2).replace('.', ',');
  } else {
    priceString = price.toFixed(2);
  }

  if (currencyPosition === CurrencyPosition.CurrencyBefore) {
    return currency + plusMinusSign + priceString;
  }

  return plusMinusSign + priceString + currency;
}
